import React from 'react';
import './App.css';
import Router from './pages/Router';

const App = () => {
  return <Router />;
};

export default App;
